import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const containerSx = {
  alignItems: 'center',
  backgroundColor: '#005d99',
  color: 'rgba(255, 255, 255, 0.88)',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
};

export function AppLoader() {
  return (
    <Box sx={containerSx}>
      <CircularProgress color="inherit" aria-label="Loading page" />
    </Box>
  );
}
